import { Stage, Layer, Rect, Text, Arrow } from 'react-konva';
import React, { useEffect, useState } from 'react';
import { Container, FormLabel, Row, Col, Button } from 'react-bootstrap';

const topviewinchtopoint = (inch) => {
  return inch*topviewinchtopointfactor;
};

const topviewinchtopointfactor = 2;
const globalh1 = 6;
const topviewinchtopointfactorheight = 10;

export const computeBoundingBox = (walls, zeroWallIndex) => {
  console.log(zeroWallIndex);
  let x = 20, y = 80;
  let minX = 0, maxX = 0;
  let minY = 0, maxY = 0;

  const placedRects = [];
  let previousangleSum = 0;

  const w1 = topviewinchtopoint(walls[zeroWallIndex].wallwidth);
  const h1 = globalh1; //walls[zeroWallIndex].wallheight/topviewinchtopointfactorheight;
  const a1 = walls[zeroWallIndex].walldirection;
  placedRects.splice(0,0,{ x, y, currentwidth:w1, currentheight:h1, currentangle:a1, previousangleSum, id:walls[zeroWallIndex].id });  

  // This code is intended to take care when inserting walls to the right
  // it doesn't work yet, but it will be similar to the above for loop
  
  for (let i = zeroWallIndex; i >= 0; i--) {
    
    const id = walls[i].id; 
    if (i<zeroWallIndex) {
      const previouswidth = topviewinchtopoint(walls[i+1].wallwidth);
      const previousheight = globalh1; //walls[i+1].wallheight/topviewinchtopointfactorheight;
      const previousangle = walls[i+1].walldirection;
      previousangleSum -= previousangle;      
      console.log(zeroWallIndex);
      console.log(previouswidth);
      console.log(previousangleSum);
      // calculate CURRENT x and y based on previouswidth, previousheight and previousangle
      switch (previousangleSum % 360) {
        case 0: //          
          switch (parseInt(walls[i].walldirection)) {
            case 90:
              x -= previousheight;
              y += previousheight;
              break;
            case -90:
              x = x + previousheight;          
              y = y + previousheight;
              break;
          }            
          break;
        case 90:
          switch (parseInt(walls[i].walldirection)) {
            case 90:
              y += previouswidth;
              break;
            case -90:
              x -= previousheight;
              y = y - previouswidth + previousheight;
              break;
          }
          break;                    
        case 180:
          switch (parseInt(walls[i].walldirection)) {
            case 90:
              x += previouswidth;  
              break;
            case -90:
              x = x + previouswidth - previousheight;
              y = y - previousheight;
              break;
          }
                  
          break;                      
        case -90: //
          switch (parseInt(walls[i].walldirection)) {
            case 90:
              y += (previouswidth + previousheight);
              x += previousheight;          
              break;
            case -90:
              y = y + previouswidth - previousheight;
              x += previousheight;          
              break;
          }              
          break;             
        case -180: 
          switch (parseInt(walls[i].walldirection)) {
            case 90:
              x += (previouswidth + previousheight);          
              y -= previousheight;
              break;
            case -90:
              x = x + previouswidth - previousheight;          
              y = y - previousheight;
              
              break;
          }            
          break;                        
      }                 
      const currentwidth = topviewinchtopoint(walls[i].wallwidth);
      const currentheight = globalh1; //walls[i+1].wallheight/topviewinchtopointfactorheight;
      const currentangle = walls[i].walldirection;
      placedRects.splice(0, 0, { x, y, currentwidth, currentheight, currentangle, previousangleSum, id });
      console.log(placedRects);
    }

    
  }

  

  // IMPORANT: These need to be the same as above
  x = 20; 
  y = 80;
  previousangleSum = 0;

  for (let i = 0; i < walls.length; i++) {
    const id = walls[i].id;  
    if (i>zeroWallIndex) {
      const previouswidth = topviewinchtopoint(walls[i-1].wallwidth);
      const previousheight = globalh1; //walls[i-1].wallheight/topviewinchtopointfactorheight;
      const previousangle = walls[i-1].walldirection;
      previousangleSum += previousangle;      
      console.log(previousangleSum);
      // calculate CURRENT x and y based on previouswidth, previousheight and previousangle
      // THIS STILL WILL NOT WORK IN ALL CASES 
      // IT'S JUST AN APPROXIMATION :'(
      switch (previousangleSum % 360) {
        case 0:
          switch (parseInt(walls[i].walldirection)) {
            case 90:
              x = x + previouswidth; 
              y = y + previousheight;
              break;
            case -90:
              x = x + previouswidth; 
              y = y + previousheight;              
              break;
          }          
          break;
        case 90:
          y += previouswidth;
          break;                    
        case 180:
          x -= previouswidth;          
          break;                      
        case -90:
          y -= previouswidth;          
          break;             
        case -180:
          x -= previouswidth;          
          break;                        
      }                 
      const currentwidth = topviewinchtopoint(walls[i].wallwidth);
      const currentheight = globalh1; //walls[i].wallheight/topviewinchtopointfactorheight;
      const currentangle = walls[i].walldirection;
      placedRects.push({ x, y, currentwidth, currentheight, currentangle, previousangleSum, id });
    }
  }
  
  

  
  

  return {
    placedRects
  };
}

export const RectanglesVisualizer = (props) => {
  const [layout, setLayout] = useState({ placedRects: [], boundingBox: {} });
  const [zeroIndex, setZeroIndex]= useState(0);
  const walls = props.walls;
  const currentWallIndex = props.currentWallIndex;

  useEffect(() => {
    console.log(walls);
    setLayout(computeBoundingBox(walls,walls.findIndex(wall => wall.walldirection ===0)));
    //setZeroIndex(walls.findIndex(wall => wall.walldirection ===0));
  }, [props.walls]);

  useEffect(() => {    
    //setZeroIndex(layout.placedRects.findIndex(rect => rect.currentangle === 0));
  }, [layout]);
  /*
  useEffect(() => {    
    setLayout(computeBoundingBox(walls,zeroIndex));
  }, [zeroIndex]);  
  */

  return (
    <>
    <Container className='mt-2' style={{borderStyle:'solid',borderWidth:'1px', margin:0, maxWidth:"500px"}}>
      <Col style={{maxWidth:"500px"}}>
        <Row style={{display:'flex',flexDirection:'row', flexWrap:'nowrap', height:'20px'}}>
          <FormLabel>Top View (You can drag the whole view)</FormLabel>
        </Row>
        <Row style={{backgroundColor:'lightgray', height:'100%', maxWidth:"500px"}}>

          <Stage width={500} height={350} draggable
            onMouseMove={(e) => {
              e.target.getStage().container().style.cursor = 'move';
            }}                   
            onMouseLeave={(e) => {
              e.target.getStage().container().style.cursor = 'default';
            }}                                           
          >
            {/* Draw walls */}
            {layout.placedRects.map((rect, i) => {
              let rotParam;
              let rotAdjx = 0;
              let rotAdjy = 0; 
              let fill = parseInt(i) === parseInt(props.currentWallIndex)?"blue":"gray";

              if (i >= zeroIndex ) {
                switch (rect.angle) {
                  case 0:
                    rotParam = 0;
                    rotAdjx = 0;
                    rotAdjy = 0;
                    break;
                  case 90:
                    rotParam = 1;
                    rotAdjx = rotParam*rect.height;
                    rotAdjy = rotParam*rect.height;                  
                    break;
                  case -90:
                    rotParam = -1;
                    rotAdjx = rotParam*rect.height;
                    rotAdjy = -rotParam*rect.height;                                      
                    break;                                    
                }   

                return (
                  <Layer>
                    <Rect
                      key={i}
                      x={rect.x}
                      y={rect.y}
                      width={rect.currentwidth}
                      height={rect.currentheight}
                      fill={fill}
                      stroke="black"
                      strokeWidth={0}
                      rotation={rect.currentangle+rect.previousangleSum}
                      offset={rect.currentangle===0?{x:0,y:0}:{ x: 0, y: rect.currentheight }}
                    />
                  </Layer>
                );
              }
            })}
          </Stage>

        </Row>
      </Col>
      

    </Container>
    </>
  );
}